
<template>
    <div class="progress-bar">
        <ul>

            <li v-bind:class="{complete: isComplete(1), 'current' : isCurrent(1)}">
                <span class="d-none d-lg-block">Dates &amp; Guests</span>
                <span class="d-lg-none number">1</span>
                <a v-if="isComplete(1)"
                   v-bind:href="getPath('stay_search')">Edit</a>
            </li>
            <li v-bind:class="{complete: isComplete(2), 'current' : isCurrent(2)}">
                <span class="d-none d-lg-block">Rooms &amp; Rates</span>
                <span class="d-lg-none number">2</span>
                <a v-if="isComplete(2)"
                   v-bind:href="getPath('stay_leg_room_availability', 1)">Edit</a>
            </li>
            <li v-bind:class="{complete: isComplete(3), 'current' : isCurrent(3)}">
                <span class="d-none d-lg-block">Add ons</span>
                <span class="d-lg-none number">3</span>
                <a v-if="isComplete(3)"
                   v-bind:href="getPath('stay_addons')">Edit</a>
            </li>
            <li v-bind:class="{complete: isComplete(4), 'current' : isCurrent(4)}">
                <span class="d-none d-lg-block">Details</span>
                <span class="d-lg-none number">4</span>
                <a v-if="isComplete(4)"
                   v-bind:href="getPath('stay_details')">Edit</a>
            </li>
            <li v-bind:class="{complete: isComplete(5), 'current' : isCurrent(5)}">
                <span class="d-none d-lg-block">Payment</span>
                <span class="d-lg-none number">5</span>
                <a v-if="isComplete(5)"
                   v-bind:href="getPath('stay_payment')">Edit</a>
            </li>
        </ul>

    </div>
</template>

<script>
    import { store } from '../store/index';

    export default {
        name: 'ProgressBar',
        computed: {
            currentStep() {
                return this.$route.name;
            },
            session() {
                return store.getters.session
            }
        },
        data() {
            return {
                paths: [
                    {
                        routeName: 'stay_start',
                        step: 1
                    },
                    {
                        routeName: "stay_search",
                        step: 1
                    },
                    {
                        routeName: 'stay_leg_room_availability',
                        step: 2
                    },
                    {
                        routeName: 'stay_leg_room_rates',
                        step: 2
                    },
                    {
                        routeName: 'stay_guests',
                        step: 2
                    },
                    {
                        routeName: 'stay_itinerary',
                        step: 2
                    },
                    {
                        routeName: 'stay_addons',
                        step: 3
                    },
                    {
                        routeName: 'stay_details',
                        step: 4
                    },
                    {
                        routeName: 'stay_summary',
                        step: 4
                    },
                    {
                        routeName: 'stay_payment',
                        step: 5
                    }
                ]

            }
        },
        methods: {
            getPath: function (routeName, leg) {
                var route = {
                    name: routeName,
                    params: {
                        id: this.session.Id
                    }
                };


                if (leg != undefined) {
                    route.params.leg = leg;
                }

                let props = this.$router.resolve(route);

                return props.href;

            },
            isComplete: function (step) {
                var path = this.paths.find(item => item.routeName == this.currentStep);
                var pathStep = path.step;
                return step < pathStep;
            },
            isCurrent: function (step) {
                var path = this.paths.find(item => item.routeName == this.currentStep);
                var pathStep = path.step;
                return step == pathStep;
            }
        }
    }
</script>

<style scoped>
    .progress-bar {
        width: 100%;
        display: flex;
        justify-content: center;
        max-width: 805px;
        margin: 0 auto;
    }

        .progress-bar ul {
            display: flex;
            flex-direction: row;
            padding: 0;
            margin: 0;
            width: 100%;
            justify-content: space-between;
            list-style: none;
        }

            .progress-bar ul li {
                display: flex;
                flex-direction: column;
                text-align: center;
                position: relative;
                text-transform: uppercase;
                font-weight: bold;
            }

                .progress-bar ul li span {
                    font-size: 14px;
                    color: #1a1a1a;
                    position: relative;
                }

                .progress-bar ul li a {
                    color: #a2905b;
                    font-size: 12px;
                }

                /*.progress-bar ul li.current:after {
                    position: absolute;
                    content: '';
                    bottom: -8px;
                    width: 60px;
                    background: #a2905b;
                    height: 2px;
                    left: 50%;
                    transform: translateX(-50%);
                }*/

                .progress-bar ul li.current span:after {
                    position: absolute;
                    content: '';
                    bottom: -8px;
                    width: 60px;
                    background: #a2905b;
                    height: 2px;
                    left: 50%;
                    transform: translateX(-50%);
                }

                .progress-bar ul li.complete span {
                    color: #7d7f80;
                    position: relative;
                }

                    .progress-bar ul li.complete span:after {
                        display: block;
                        content: '';
                        height: 1px;
                        width: 20px;
                        background: #7d7f80;
                        right: -55px;
                        top: 12px;
                        position: absolute;
                    }

                    .progress-bar .number{
                        width: 40px;
                        height: 40px;
                        border: solid 1px rgba(0,0,0,0.2);
                        border-radius: 50%;
                        line-height: 40px;
                        margin-bottom: 10px
                    }


        .progress-bar ul li.complete .number {
            border: solid 1px #a18f5b;
        }

        .progress-bar ul li.current .number {
            border: solid 1px #a18f5b;
            background: #fff;
        }


    @media (max-width: 991px) {
        .progress-bar ul li.complete span:after,
        .progress-bar ul li.current:after {
            display: none;
        }
    }
    
</style>